import { apiRequest } from "./http";
import {
  GuardianConsentDetail,
  GuardianConsentDocumentPreview,
  GuardianConsentSubmitResponse,
} from "../types/guardianConsent";

export const fetchGuardianConsent = (linkId: string) =>
  apiRequest<GuardianConsentDetail>(`/public/guardian-consent/${encodeURIComponent(linkId)}`, {
    withAuth: false,
  });

export const fetchGuardianConsentDocumentPreview = (linkId: string) =>
  apiRequest<GuardianConsentDocumentPreview>(
    `/public/guardian-consent/${encodeURIComponent(linkId)}/document-preview`,
    { withAuth: false }
  );

export const submitGuardianConsent = (linkId: string, formData: FormData) =>
  apiRequest<GuardianConsentSubmitResponse>(
    `/public/guardian-consent/${encodeURIComponent(linkId)}/submit`,
    {
      method: "POST",
      body: formData,
      withAuth: false,
    }
  );
